import React, { useState, useContext } from "react";
import { Col, Form, Table } from "react-bootstrap";
import { SettingsContext } from './AccountSettingsButton'
import jsDig from "utils/jsDig.js";
import { v4 as uuidv4 } from "uuid";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";

export default function DataPulseScripts(props) {

  const context = useContext(SettingsContext);

  console.log("Context: ", context)

  const handleCheckbox = (e, name) => {
    context.setDataPulseScripts({
      ...context.dataPulseScripts,
      [name]: e.target.checked ? "1" : "0"
    });
  }

  const handleScriptVariableChange = (e, scriptName, optionName) => {
    context.setScriptVariables({
      ...context.scriptVariables,
      [scriptName]: {
        ...context.scriptVariables[scriptName],
        [optionName]: e.target.value
      }
    });
  }

  const handleScriptVariableCheckboxChange = (e, scriptName, optionName) => {
    context.setScriptVariables({
      ...context.scriptVariables,
      [scriptName]: {
        ...context.scriptVariables[scriptName],
        [optionName]: e.target.checked ? "1" : "0"
      }
    });
  }

  return (
    <>
      {props.scripts.map((script) => {
        return (
          <div key={script.name} className="script-box text-primary p-3">
            <div className="h-100 script-box-bg">
              <div className="mb-2">
                <div className="lite-checkbox-container">
                  <input
                    type="checkbox"
                    className="lite-checkbox "
                    id={`datapulse_scripts_${script.name}`}
                    name={`datapulse_scripts[${script.name}]`}
                    onChange={(e) => {
                      handleCheckbox(e, script.name)
                    }}
                    defaultChecked={
                      context.dataPulseScripts[script.name] == "1" ? true : false     
                    }
                    />
                  <label className="custom-label script-title" htmlFor={`datapulse_scripts_${script.name}`}>{script.title}</label>
                </div>
              </div>
              <div>
                <p className="f12">{script.desc}</p>
              </div>
              {script.options && (
                <div className="script-options pt-2">
                  <div className="script-options d-flex flex-column" style={{gap: "8px"}}>
                    {script.options.map((option) => {
                      return (
                        <div className="mb-0 form-group" key={`${script.name}-${option.name}`}>
                          <label className="f12 font-weight-bold pb-2 form-label" htmlFor={`script_variables[${script.name}][${option.name}]`}>
                            {option.title}
                          </label>
                          {option.desc && (
                            <p className="f12 mb-2"><i>{option.desc}</i></p>
                          )}
                          {option.type && option.type == "checkbox" ? (
                            <input
                              type="checkbox"
                              className="lite-checkbox"
                              id={`script_variables[${script.name}][${option.name}]`}
                              name={`script_variables[${script.name}][${option.name}]`}
                              onChange={(e) => {
                                handleScriptVariableCheckboxChange(e, script.name, option.name);
                              }}
                              defaultChecked={
                                jsDig([script.name, option.name], context.scriptVariables) == "1" ? true : false
                              }
                            />
                          ) : (
                            <input 
                              name={`script_variables[${script.name}][${option.name}]`} 
                              placeholder={option.placeholder} 
                              id={`script_variables[${script.name}][${option.name}]`} 
                              className="d-inline form-control form-control-sm" 
                              defaultValue={jsDig([script.name, option.name], context.scriptVariables)}
                              onChange={(e) => {
                                handleScriptVariableChange(e, script.name, option.name);
                              }}
                            ></input>
                          )}
                          
                        </div>
                      )
                    })}
                  </div>
                    
                </div>
              )}
            </div>
          </div>
        );
      })}
    </>
  );
}